import { Alert, Box, List } from '@ksyos/design-system';

export function HomeHolterAlert() {
    return (
        <Alert appearance="info">
            <Alert.Text
                fontWeight="bold"
                mb={3}
            >
                Let op: je gaat een Thuis Holter aanvragen
            </Alert.Text>
            <Box maxWidth="60ch">
                <List styleType="bullet">
                    <List.Item>
                        De Thuis Holter wordt per post naar de patiënt gestuurd. De patiënt dient hier zelf thuis mee
                        aan de slag te gaan
                    </List.Item>
                    <List.Item>
                        Het is van belang dat je de patiënt goed inlicht. De patiënt moet zelf de holter opplakken, het
                        onderzoek starten en de holter weer terugsturen naar de praktijk
                    </List.Item>
                </List>
            </Box>
        </Alert>
    );
}
